import male01 from './male01.jpg';
import male02 from './male02.jpg';
import male04 from './male04.jpg';
import male05 from './male05.jpg';
import male06 from './male06.jpg';
import male07 from './male07.jpg';
import male08 from './male08.jpg';
import female01 from './Female01.jpg';
import female02 from './Female02.jpg';
import female03 from './Female03.jpg';
import female04 from './Female04.jpg';
import female05 from './Female05.jpg';
import female06 from './Female06.jpg';
import female07 from './Female07.jpg';
import female08 from './Female08.jpg';
import female09 from './Female09.jpg';
import female10 from './Female10.jpg';

export const memberNamesAndImagesMap = {
  'Dr. Carter Reid': male01,
  'Priya Patel': female09,
  'Dr. Hugo Wang': male08,
  'Dr. Bella James': female08,
  'Dr. Adam Brooks': male02,
  'Zoe Walsh': female02,
  'Dr. Simon Clark': male04,
  'Dr. Juliet Song': female01,
  'Angela Fox': female03,
  'Dr. Anil Kumar': male07,
  'Emily Wade': female04,
  'Dr. Ruby Shaw': female05,
  'Dr. Chris Moon': male05,
  'Nina Singh': female10,
  'Dr. Lucas Field': male06,
  'Dr. Grace Park': female06,
  'Ivy Atkins': female07,
};

export default memberNamesAndImagesMap;
